// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderFilledSvg from "@ant-design/icons-svg/es/asn/FolderFilled";
import AntdIcon from '../components/AntdIcon';

var FolderFilled = function FolderFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderFilledSvg
  }));
};

FolderFilled.displayName = 'FolderFilled';
export default React.forwardRef(FolderFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderFilled.js
// module id = 1193
// module chunks = 0